import { TrendingUp, Minus, Activity, Smile, MoveUp } from "lucide-react";

const ResultsSection = () => {
  const results = [
    { icon: Minus, label: "Reduced Abdominal Gap", color: "text-blue-600" },
    { icon: Activity, label: "Improved Core Strength", color: "text-emerald-600" },
    { icon: TrendingUp, label: "Reduced Back Pain", color: "text-blue-600" },
    { icon: MoveUp, label: "Better Posture", color: "text-pink-600" },
    { icon: Smile, label: "Increased Confidence", color: "text-amber-600" },
  ];

  return (
    <section id="results" className="section-spacing bg-white" data-testid="results-section">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              Real Results
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-testid="results-headline">
              Real Women. Real Recovery.
            </h2>
            <p className="text-lg text-stone-600 mb-8">
              Many of our patients report significant improvements within weeks of starting their personalized treatment program.
            </p>

            {/* Results List */}
            <div className="space-y-4" data-testid="results-list">
              {results.map((result, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-stone-50 rounded-xl p-4 hover:bg-pink-50 transition-colors"
                  data-testid={`result-item-${index}`}
                >
                  <div className={`w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm ${result.color}`}>
                    <result.icon size={24} />
                  </div>
                  <span className="text-lg font-medium text-stone-700">{result.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl img-zoom">
              <img
                src="https://images.pexels.com/photos/8436479/pexels-photo-8436479.jpeg"
                alt="Woman doing recovery exercises"
                className="w-full h-[500px] object-cover"
                data-testid="results-image"
              />
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 left-6 right-6 bg-white rounded-2xl p-6 shadow-xl border border-blue-100" data-testid="results-stats">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-blue-700">8-16</p>
                  <p className="text-xs md:text-sm text-stone-500">Weeks Program</p>
                </div>
                <div className="border-x border-stone-200">
                  <p className="text-2xl md:text-3xl font-bold text-emerald-600">95%</p>
                  <p className="text-xs md:text-sm text-stone-500">Success Rate</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-pink-600">0</p>
                  <p className="text-xs md:text-sm text-stone-500">Surgery Needed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
